import * as ResourcesConstants from 'constants/ResourcesConstants'
import { CustomerAPI } from '@driftt/dapper'
import {
  getAuthorizationHeader,
  RequestContentType,
  encodeQueryData,
  serializeObject
} from 'utils/Helpers'
import { toISOLocalDateString } from 'utils/DateHelpers'

const EndUserAPI = Marty.createStateSource({
  id: 'EndUserAPI',
  type: 'http',
  baseUrl: ResourcesConstants.CUSTOMER_API,

  fetchEndUser(endUserId) {
    return this.get({
      url: `/end_users/${ endUserId }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchEndUserTimeLine(endUserId, query) {
    return this.get({
      url: `/end_users/${ endUserId }/timeline?${ encodeQueryData(query) }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchEndUsers(endUserIds) {
    return this.post({
      url: '/end_users/find',
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify({
        endUserIds
      })
    })
  },

  fetchEndUserSegments(endUserId, orgId) {
    return this.get({
      url: `/end_users/${ endUserId }/memberships?orgId=${ orgId }`,
      headers: getAuthorizationHeader()
    })
  },

  createEndUserForOrgId(endUser, orgId) {
    return this.post({
      url: `/organizations/${ orgId }/end_users`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(endUser)
    })
  },

  searchEndUser(orgId, query) {
    return this.get({
      url: `/organizations/${ orgId }/end_users/search?q=${ encodeURI(query) }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchOrgEndUserCountHistory(orgId, startDate, endDate) {
    const queryParams = serializeObject({
      startDate: toISOLocalDateString(startDate),
      endDate: toISOLocalDateString(endDate)
    })
    return this.get({
      url: `/organizations/${ orgId }/end_users/count/histogram?${ queryParams }`,
      headers: getAuthorizationHeader()
    })
  },

  fetchOrgEndUserCount(orgId, startDate) {
    const query = startDate ? `?startDate=${ startDate }` : ''
    return this.get({
      url: `/organizations/${ orgId }/end_users/count${ query }`,
      headers: getAuthorizationHeader()
    })
  },

  elasticSearchEndUser(orgId, query, from, size, sortField, sortDirection) {
    const sizeQuery = {}
    if (from != null) { sizeQuery.from = from }
    if (size != null) { sizeQuery.size = size }
    const sortQuery = {}
    if (sortField != null) { sortQuery.sortField = sortField }
    if (sortDirection != null) { sortQuery.sortDirection = sortDirection }
    return this.post({
      url: `/organizations/${ orgId }/end_users/search?${ encodeQueryData(sizeQuery) }&${ encodeQueryData(sortQuery) }`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: query
    })
  },

  updateEndUser(endUserId, endUserParams, accessToken) {
    return this.patch({
      url: `/end_users/${ endUserId }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(accessToken),
      body: JSON.stringify(endUserParams)
    })
  },

  deleteBySegment(orgId, segmentId) {
    return CustomerAPI.delete(`/organizations/${orgId}/end_users/user_list/${segmentId}`)
  },

  unsubscribeEndUser(endUserId, campaignId, reason) {
    if (campaignId) {
      return this.post({ url: `/unsubscribe/enduser/${endUserId}?${encodeQueryData({ campaignId, reason })}` })
    } else {
      return this.post({ url: `/unsubscribe/enduser/${endUserId}?${encodeQueryData({ reason })}` })
    }
  },

  fetchEndUserAttributesForOrg(orgId) {
    return this.get({
      url: `/organizations/${ orgId }/end_users/attributes2`,
      headers: getAuthorizationHeader()
    })
  },

  uploadFileToImportEndUsers(file) {
    const data = new FormData()
    data.append('file', file)
    return this.post({
      url: '/csvimport',
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.FORM_DATA,
      body: data
    })
  },

  getCSVImport(id) {
    return this.get({
      url: `/csvimport/${ id }`,
      headers: getAuthorizationHeader()
    })
  },

  updateCSVImport(id, params) {
    return this.patch({
      url: `/csvimport/${ id }`,
      contentType: RequestContentType.JSON,
      headers: getAuthorizationHeader(),
      body: JSON.stringify(params)
    })
  },

  initiateCSVImport(id, mapping) {
    return this.post({
      url: `/csvimport/${ id }/start`,
      headers: getAuthorizationHeader(),
      contentType: RequestContentType.JSON,
      body: JSON.stringify(mapping)
    })
  }

})

export default EndUserAPI



// WEBPACK FOOTER //
// ./src/scripts/sources/EndUserAPI.js